import React, { createContext, useState, useEffect, useContext } from 'react';
import { getConfig } from '../config';
import apiServicewt from '../api/apiServicewt';
import { useLanguageSwitch } from '../contexts/LanguageSwitchContext';

const LoginSettingsContext = createContext();

export const LoginSettingsProvider = ({ children }) => {
	const [loginSettings, setLoginSettings] = useState({});
	const [loginSettingsLang, setLoginSettingsLang] = useState({});
	const [loading, setLoading] = useState(true);
	const { setIsLangSwitchEnabled } = useLanguageSwitch();

	useEffect(() => {
		const fetchSettings = async () => {
			try {
				const item = { action: 'get_login_settings' };
				const flechdata = await apiServicewt(item);
				if (flechdata.type === 'Success' || flechdata.type === 'success') {
					setLoginSettings(flechdata.data);
				}
			} catch (err) {
				console.error('Failed to fetch login settings:', err);
			} finally {
				setLoading(false);
			}
		};

		const fetchSettingsLang = async () => {
			try {
				const item = { action: 'get_settings' };
				const flechdata = await apiServicewt(item);
				if (flechdata.type === 'Success' || flechdata.type === 'success') {
					setLoginSettingsLang(flechdata.data);
					setIsLangSwitchEnabled(flechdata.data.userweb_lang_switch === '1');
				}
			} catch (err) {
				console.error('Failed to fetch login settings lang:', err);
			} finally {
				setLoading(false);
			}
		};

		fetchSettings();
		fetchSettingsLang();
	}, []);

	return (
		<LoginSettingsContext.Provider value={{ loginSettings, loading }}>
			{children}
		</LoginSettingsContext.Provider>
	);
};

export const useLoginSettings = () => useContext(LoginSettingsContext);
